<template>
  <g class="arm400">
      <g class="armholder">
        <polygon class="armholder-front" points="1779.69 2615.72 1727.73 2585.72 1727.73 2465.72 1779.69 2495.72 1779.69 2615.72" fill="#7793bf"/>
        <polygon class="armholder-right" points="1788.36 2610.72 1779.7 2615.72 1779.7 2495.72 1788.36 2490.72 1788.36 2610.72" fill="#3d6199"/>
      </g>
      <polygon class="rightarm400 rightside" data-name="rightarm400 rightside" points="1770.59 2578.47 1424.18 2778.47 1424.18 2738.47 1770.59 2538.47 1770.59 2578.47" fill="#365593"/>
      <polygon class="toparm400 topside" data-name="toparm400 topside" points="1770.59 2538.47 1424.18 2738.47 1389.54 2718.47 1735.95 2518.47 1770.59 2538.47" fill="#5070af"/>
      <g class="armfront">
        <polygon class="innertop topside" data-name="innertop topside" points="1424.18 2778.47 1389.54 2758.47 1389.54 2718.47 1424.18 2738.47 1424.18 2778.47" fill="#5070af"/>
        <polygon class="innerright rightside" data-name="innerright rightside" points="1389.54 2718.47 1389.54 2758.47 1424.18 2738.47 1389.54 2718.47" fill="#365593"/>
      </g>
      <g class="double-arm400" v-if="doubleBranch">
        <polygon class="darm400 rightside" data-name="darm400 rightside" points="1814.35 2553.2 2151.64 2358.47 2151.64 2318.47 1814.33 2513.22 1814.35 2553.2" fill="#3e5c96"/>
        <polygon class="darm400_frontside" data-name="darm400 frontside" points="1814.33 2513.22 2151.64 2318.47 2117 2298.47 1814.35 2473.2 1814.33 2513.22" fill="#5070af"/>
        <polygon class="armholder-right-10px-2" data-name="armholder-right-10px" points="1814.33 2595.44 1805.67 2600.44 1805.67 2480.44 1814.33 2475.44 1814.33 2595.44" fill="#3d6199"/>
      </g>
    </g>
</template>
<script>
export default {
  props: {
    doubleBranch: Boolean,
  },

  name: "Arm400-B.vue",
};
</script>